import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {defineMessages, injectIntl, intlShape} from 'react-intl';

// import back from './back.png'
import GreenFlag from '../green-flag/green-flag.jsx';
import StopAll from '../stop-all/stop-all.jsx';
// import TurboMode from '../turbo-mode/turbo-mode.jsx';
// import greenFlagIcon from './icon--green-flag.svg';
import block from './block.png';
import details from './description.png';
import start from './scratch-start.png';
import stop from './scratch-stop.png';

// import styles from './green-flag.css';

import styles from './controls.css';


const messages = defineMessages({
    goTitle: {
        id: 'gui.controls.go',
        defaultMessage: 'Go',
        description: 'Green flag button title'
    },
    stopTitle: {
        id: 'gui.controls.stop',
        defaultMessage: 'Stop',
        description: 'Stop button title'
    }
});

const Controls = function (props) {
    const {
        active,
        onBack,
        className,
        intl,
        isMobile,
        onGoCode,
        onGreenFlagClick,
        onStopAllClick,
        onWorkDetails,
        turbo,
        workInfo,
        workButState,
        description,
        ...componentProps
    } = props;

    let content = null;

    if (isMobile) {
        content = (
            <div
                className={classNames(styles.controlsContainer, className, styles.isMobile)}
                {...componentProps}
            >
                {/*去除返回按钮*/}
                {/*<div className={styles.back}>*/}
                {/*    <img*/}
                {/*        src={back}*/}
                {/*        alt="返回"*/}
                {/*        onClick={onBack}*/}
                {/*    />*/}
                {/*</div>*/}
                {/*{workButState ?*/}
                {/*    <GreenFlag*/}
                {/*        isMobile={isMobile}*/}
                {/*        active={active}*/}
                {/*        title={intl.formatMessage(messages.goTitle)}*/}
                {/*        onClick={onGreenFlagClick}*/}
                {/*    /> :*/}
                {/*    <StopAll*/}
                {/*        isMobile={isMobile}*/}
                {/*        active={active}*/}
                {/*        title={intl.formatMessage(messages.stopTitle)}*/}
                {/*        onClick={onStopAllClick}*/}
                {/*    />*/}
                {/*}*/}
                <div className={styles.back} onClick={workButState ? onGreenFlagClick : onStopAllClick}>
                    <img
                        src={workButState ? start : stop}
                    />
                    <span>{workButState ? '运行' : '停止'}</span>
                </div>

                <div className={styles.back} onClick={onGoCode}>
                    <img
                        src={block}
                    />
                    <span>源码</span>
                </div>
                {
                    workInfo.manual || workInfo.description  ?
                        <div className={styles.back} onClick={onWorkDetails}>
                            <img
                                src={details}
                            />
                            <span>简介</span>
                        </div> : null
                }

            </div>
        )
    } else {
        content = (
            <div
                className={classNames(styles.controlsContainer, className)}
                {...componentProps}
            >
                <GreenFlag
                    active={active}
                    title={intl.formatMessage(messages.goTitle)}
                    onClick={onGreenFlagClick}
                />
                <StopAll
                    active={active}
                    title={intl.formatMessage(messages.stopTitle)}
                    onClick={onStopAllClick}
                />
            </div>
        )
    }

    return (
        <div
            className={classNames(styles.controlsContainer, className)}
            {...componentProps}
        >
            {content}
        </div>
    );
};

Controls.propTypes = {
    active: PropTypes.bool,
    onBack: PropTypes.func,
    className: PropTypes.string,
    intl: intlShape.isRequired,
    onGreenFlagClick: PropTypes.func.isRequired,
    onStopAllClick: PropTypes.func.isRequired,
    turbo: PropTypes.bool,
    workButState: PropTypes.bool,
    onGoCode: PropTypes.func,
    onWorkDetails: PropTypes.func,
    workInfo: PropTypes.object,
    description: PropTypes.object,
};

Controls.defaultProps = {
    active: false,
    turbo: false
};

export default injectIntl(Controls);
